import { environment } from '@/config/environment';
import { useAuth } from '@/hooks/useAuth';
import { useBranding } from '@/hooks/useBranding';

export function resolveAnnouncementSenderName(
  brandName: string,
  productBrandName: string,
  workspaceName: string | null
): string {
  const hasWorkspaceBrandName = brandName !== productBrandName;
  if (hasWorkspaceBrandName === true || workspaceName === null) {
    return brandName;
  }
  return workspaceName;
}

export function useAnnouncementSenderName(): string {
  const { activeMembership } = useAuth();
  const { brandName } = useBranding();
  const workspaceName = activeMembership === null ? null : activeMembership.tenantName;
  return resolveAnnouncementSenderName(brandName, environment.brandName, workspaceName);
}
